module.exports = __webpack_public_path__ + "img/jinse-logo.fddc63e8.png";